import { render, staticRenderFns } from "./QuestionDetails.vue?vue&type=template&id=5326fee6&scoped=true&"
import script from "./QuestionDetails.vue?vue&type=script&lang=js&"
export * from "./QuestionDetails.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDetails.vue?vue&type=style&index=0&id=5326fee6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5326fee6",
  null
  
)

export default component.exports